<template>
  <el-row :gutter="15">
    <el-col
      :xs="12"
      :sm="8"
      :md="7"
      :lg="6"
      :xl="4"
    >
      <el-card
        shadow="never"
        header="Freight Reports"
      >
        <el-menu
          :default-active="activeList"
          class="border-0"
          @select="index => { activeList = index }"
        >
          <el-menu-item index="FreightDetail">
            <FontAwesomeIcon
              :icon="[ 'fal', 'truck-container' ]"
              size="lg"
            />
            <span class="pl-3">Freight Detail</span>
          </el-menu-item>

          <el-menu-item index="FreightSummary">
            <FontAwesomeIcon
              :icon="[ 'fal', 'calculator-alt' ]"
              size="lg"
            />
            <span class="pl-3">Freight Summary</span>
          </el-menu-item>

          <el-menu-item index="FreightBestPrice">
            <FontAwesomeIcon
              :icon="[ 'fal', 'lightbulb-dollar' ]"
              size="lg"
            />
            <span class="pl-3">Best Price Report</span>
          </el-menu-item>

          <el-menu-item index="FreightZones">
            <FontAwesomeIcon
              :icon="[ 'fal', 'globe' ]"
              size="lg"
            />
            <span class="pl-3">Freight Zones</span>
          </el-menu-item>

          <el-menu-item index="PortfolioFreightUsage">
            <FontAwesomeIcon
              :icon="[ 'fal', 'tachometer-alt-fast' ]"
              size="lg"
            />
            <span class="pl-3">Portfolio Freight Usage</span>
          </el-menu-item>

          <el-menu-item index="ItemReport">
            <FontAwesomeIcon
              :icon="[ 'fal', 'boxes-alt' ]"
              size="lg"
            />
            <span class="pl-3">Consignment Items</span>
          </el-menu-item>

          <el-menu-item index="Billing">
            <FontAwesomeIcon
              :icon="[ 'fal', 'money-bill-alt' ]"
              size="lg"
            />
            <span class="pl-3">Billing Report</span>
          </el-menu-item>

          <el-menu-item index="LateConsignment">
            <FontAwesomeIcon
              :icon="[ 'fal', 'calendar-times' ]"
              size="lg"
            />
            <span class="pl-3">Late Consignment Report</span>
          </el-menu-item>

          <el-menu-item index="DistanceMatrix">
            <FontAwesomeIcon
              :icon="[ 'fal', 'map-signs' ]"
              size="lg"
            />
            <span class="pl-3">Distance Matrix</span>
          </el-menu-item>
        </el-menu>
      </el-card>
    </el-col>

    <el-col
      :xs="12"
      :sm="16"
      :md="17"
      :lg="18"
      :xl="20"
    >
      <el-card shadow="never">
        <template #header>
          <span>{{ `${$filters.titleize(activeList)} Report` }}</span>
        </template>
        <component
          :is="activeList"
          ref="list"
        />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import FreightDetail from '@/components/Application/Reports/Freight/Detail'
import FreightSummary from '@/components/Application/Reports/Freight/Summary'
import FreightZones from '@/components/Application/Reports/Freight/Zones'
import PortfolioFreightUsage from '@/components/Application/Reports/Freight/PortfolioFreightUsage'
import FreightBestPrice from '@/components/Application/Reports/Freight/BestPrice'
import ItemReport from '@/components/Application/Reports/Freight/ItemReport'
import Billing from '@/components/Application/Reports/Freight/Billing'
import LateConsignment from '@/components/Application/Reports/Freight/LateConsignment'
import DistanceMatrix from '@/components/Application/Reports/Freight/DistanceMatrix'

export default {
  components: {
    FreightDetail,
    FreightSummary,
    FreightZones,
    PortfolioFreightUsage,
    FreightBestPrice,
    ItemReport,
    Billing,
    LateConsignment,
    DistanceMatrix
  },
  data () {
    return {
      title: 'Freight Reports',
      breadcrumb: {
        name: 'Freight Reports',
        route: { name: 'reports-freight' }
      },
      activeList: 'FreightDetail'
    }
  }
}
</script>
